export const StudentProfileTranslations = {
  PROFILE: {
    es: 'Perfil',
    en: 'Profile',
    cat: 'Perfil',
    eus: 'Profila',
    pt: 'Perfil'
  },
  EDIT_PROFILE: {
    es: 'Editar perfil',
    en: 'Edit profile',
    cat: 'Edita el perfil',
    eus: 'Profila editatu',
    pt: 'Editar perfil'
  },
  ABOUT_ME: {
    es: 'Sobre mí',
    en: 'About me',
    cat: 'Sobre mi',
    eus: 'Niri buruz',
    pt: 'Sobre mim'
  },
  SEE_MORE: {
    es: 'Ver más',
    en: 'See more',
    cat: 'Veure més',
    eus: 'Gehiago ikusi',
    pt: 'Ver mais'
  },
  I_AM_STUDYING: {
    es: 'Estoy estudiando',
    en: 'Studying',
    cat: 'Estic estudiant',
    eus: 'Ikasten ari naiz',
    pt: 'Estou estudando'
  },
  STATS: {
    es: 'Estadísticas',
    en: 'Statistics',
    cat: 'Estadístiques',
    eus: 'Estatistikak',
    pt: 'Estatísticas'
  },
  POINTS: {
    es: 'puntos',
    en: 'points',
    cat: 'punts',
    eus: 'puntu',
    pt: 'pontos'
  },
  DAYS: {
    es: 'días',
    en: 'days',
    cat: 'dies',
    eus: 'egun',
    pt: 'dias'
  },
  LONGEST_STREAK: {
    es: 'racha más larga',
    en: 'longest streak',
    cat: 'ratxa més llarga',
    eus: 'lerro luzeena',
    pt: 'maior sequência'
  },
  TOTAL_PROGRESS: {
    es: 'avance total',
    en: 'total progress',
    cat: 'progrés total',
    eus: 'aurrerapen osoa',
    pt: 'progresso total'
  },
  STREAK_DAYS: {
    es: '{{days}} días',
    en: '{{days}} days',
    cat: '{{days}} dies',
    eus: '{{days}} egun',
    pt: '{{days}} dias'
  },
  AVERAGE_SCORE: {
    es: 'nota media',
    en: 'average score',
    cat: 'nota mitjana',
    eus: 'batazbesteko nota',
    pt: 'nota média'
  },
  ADD_DESCRIPTION: {
    es: 'Aún no has añadido información sobre ti',
    en: 'You have not added any information about yourself',
    cat: 'Encara no has afegit informació sobre tu',
    eus: 'Ez dituzu informazio bat gehitu',
    pt: 'Ainda não adicionou informação sobre si'
  }
};
